import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGenerateAllAudioBody } from './generate-all-audio-request';
import type { IGenerateAllAudioResponse } from './generate-all-audio-response';
import { generateAllAudioResponseSchema } from './generate-all-audio-response';

export async function generateAllAudioApi(
  challengeId: number,
  body: IGenerateAllAudioBody,
): Promise<IValidatedResponse<IGenerateAllAudioResponse>> {
  return postRequest<IGenerateAllAudioResponse>({
    path: `/sys/challenges/${challengeId}/audio/generate-all`,
    body,
    schema: generateAllAudioResponseSchema,
  });
}
